import "core-js/modules/es.array.concat.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-tab', {
    staticClass: "mt-5",
    attrs: {
      "title": "Cliente",
      "active": _vm.isTheCurrentTab,
      "disabled": !_vm.isTheCurrentTab
    }
  }, [_c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "Nome",
      "label-for": "nome"
    }
  }, [_c('VueSelect', {
    ref: "buscarCliente",
    class: {
      hasErrors: _vm.clienteError,
      inputFilled: _vm.clienteFilled
    },
    attrs: {
      "filterable": false,
      "options": _vm.clients
    },
    on: {
      "input": _vm.setCliente,
      "search": _vm.onSearchCliente
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-flex justify-content-between"
        }, [_c('div', [_vm._v(" " + _vm._s(option.nome) + " ")]), _c('span', {
          staticClass: "text-muted"
        }, [_vm._v("CPF/CNPJ: " + _vm._s(_vm.formatCpfCnpj(option.cnpj_cpf)))])])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.nome) + " ")])];
      }
    }]),
    model: {
      value: _vm.store.formCliente,
      callback: function callback($$v) {
        _vm.$set(_vm.store, "formCliente", $$v);
      },
      expression: "store.formCliente"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v("Informe o nome do cliente")])], 2)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "CPF/CNPJ",
      "label-for": "cnpj_cpf"
    }
  }, [_c('b-form-input', {
    key: _vm.keyToReRender,
    attrs: {
      "disabled": "",
      "id": "cnpj_cpf",
      "name": "cnpj_cpf"
    },
    model: {
      value: _vm.store.formCliente.cnpj_cpf,
      callback: function callback($$v) {
        _vm.$set(_vm.store.formCliente, "cnpj_cpf", $$v);
      },
      expression: "store.formCliente.cnpj_cpf"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "8"
    }
  }, [_c('b-form-group', {
    key: _vm.keyToReRender,
    attrs: {
      "label": "Endereço",
      "label-for": "endereco"
    }
  }, [_c('VueSelect', {
    ref: "endereco",
    class: {
      hasErrors: _vm.enderecoError,
      inputFilled: _vm.enderecoFilled
    },
    attrs: {
      "filterable": false,
      "options": _vm.enderecos,
      "value": _vm.valueAdress
    },
    on: {
      "input": _vm.setEndereco,
      "search": _vm.onSearchEndereco
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        var _option$cep, _option$logradouro, _option$numero, _option$bairro, _option$cidade$cidade, _option$cidade, _option$cidade$uf, _option$cidade2;
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s("".concat((_option$cep = option.cep) !== null && _option$cep !== void 0 ? _option$cep : "", ", ").concat((_option$logradouro = option.logradouro) !== null && _option$logradouro !== void 0 ? _option$logradouro : "", ", ").concat((_option$numero = option.numero) !== null && _option$numero !== void 0 ? _option$numero : "", ", ").concat((_option$bairro = option.bairro) !== null && _option$bairro !== void 0 ? _option$bairro : "", " - ").concat((_option$cidade$cidade = option === null || option === void 0 || (_option$cidade = option.cidade) === null || _option$cidade === void 0 ? void 0 : _option$cidade.cidade) !== null && _option$cidade$cidade !== void 0 ? _option$cidade$cidade : "", " / ").concat((_option$cidade$uf = option === null || option === void 0 || (_option$cidade2 = option.cidade) === null || _option$cidade2 === void 0 ? void 0 : _option$cidade2.uf) !== null && _option$cidade$uf !== void 0 ? _option$cidade$uf : "")) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.label) + " ")])];
      }
    }])
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o Endereço ")])], 2)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };